import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { postBoardsUserRoles } from '../requests';
import type { PostBoardsUserRolesRequestType } from '../types';

export type UsePostBoardsUserRolesMutationParams = Omit<
  PostBoardsUserRolesRequestType,
  'boardId'
> & {
  boardId?: number;
};

export const usePostBoardsUserRoles = (specBoardId?: number) => {
  const queryClient = useQueryClient();
  const currentBoardId = useGetCurrentBoardId();
  const boardId = (specBoardId || currentBoardId) as number;

  return useMutation({
    mutationFn: (data: UsePostBoardsUserRolesMutationParams) =>
      postBoardsUserRoles({
        ...data,
        boardId,
      }),
    onSuccess: (_, variables) =>
      Promise.all(
        variables.documentIds.map(documentId =>
          queryClient.invalidateQueries({
            queryKey: [API_QUERY_KEYS.documentsUserRoles, { documentId }],
          }),
        ),
      ),
  });
};
